module.exports = __webpack_public_path__ + "static/media/indianSpinalInjury.78d03a61.webp";